import { Icon, IconProps } from '@chakra-ui/react';
import { theme } from '../../../shared/theme';

export type IconTheme = 'warning' | 'default';

type DotIconProps = IconProps & {
  theme?: IconTheme;
};

export const DotIcon = (props: DotIconProps) => {
  const { theme: selectedTheme, ...iconProps } = props;
  let fill = 'none';
  let stroke = theme.colors.gray[500];
  if (selectedTheme === 'warning') {
    fill = theme.colors.warning[500];
    stroke = theme.colors.warning[500];
  }
  return (
    <Icon
      viewBox="0 0 20 20"
      width="20px"
      height="20px"
      {...iconProps}
      color={
        selectedTheme === 'warning'
          ? theme.colors.warning[500]
          : theme.colors.gray[500]
      }
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20px"
        height="20px"
        viewBox="0 0 20 20"
        fill={fill}
      >
        <circle cx="10" cy="10" r="3.25" stroke={stroke} strokeWidth="1.5" />
      </svg>
    </Icon>
  );
};
